import { NgFor } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { TabelaComponent } from '../../shared/tabela/tabela.component';
import { PQRManutencaoFormacaoMaterialDto } from '../../dtos/pqr-manutencao-formacao-material.dto';

@Component({
  selector: 'app-dialog-pqr-manutencao-das-escolas',
  standalone: true,
  imports: [
    NgFor,
    MatDialogModule,
    MatButtonModule,
    TabelaComponent
  ],
  templateUrl: './dialog-pqr-manutencao-das-escolas.component.html',
  styleUrl: './dialog-pqr-manutencao-das-escolas.component.scss'
})
export class DialogPqrManutencaoDasEscolasComponent {
  @Input() dados: PQRManutencaoFormacaoMaterialDto[] = [];
}
